import React from "react";

export const SEMAPHORE = {
  vencido: { label: "Vencido", dot: "bg-rose-500", cls: "bg-rose-50 text-rose-700 border-rose-100" },
  proximo: { label: "Por vencer", dot: "bg-amber-500", cls: "bg-amber-50 text-amber-700 border-amber-200" },
  vigente: { label: "Vigente", dot: "bg-emerald-500", cls: "bg-emerald-50 text-emerald-700 border-emerald-100" },
  sin_vencimiento: { label: "Sin vencimiento", dot: "bg-neutral-400", cls: "bg-neutral-100 text-neutral-600 border-neutral-200" },
  sin_documentos: { label: "Sin documentos", dot: "bg-amber-400", cls: "bg-amber-50 text-amber-800 border-amber-200" },
};

export const SemaphoreBadge = ({ status, days, compact = false, testid }) => {
  const s = SEMAPHORE[status] || SEMAPHORE.sin_vencimiento;
  const extra = status === "proximo" && days != null ? ` · ${days}d` : status === "vencido" && days != null ? ` · ${Math.abs(days)}d` : "";
  return (
    <span className={`inline-flex items-center gap-1.5 rounded-full border font-semibold whitespace-nowrap ${compact ? "px-1.5 py-0 text-[10px]" : "px-2 py-0.5 text-[11px]"} ${s.cls}`} data-testid={testid}>
      <span className={`w-2 h-2 rounded-full ${s.dot}`}/>{s.label}{extra}
    </span>
  );
};

export default SemaphoreBadge;
